export default "__VITE_ASSET__Dhl01xPP__"